import { useEffect, useState, createContext, useContext } from "react";
import { media } from "../../assets/media";

const isImage = (src) => /\.(jpe?g|png)$/i.test(src);
const isVideo = (src) => /\.mp4$/i.test(src);

const loadImage = (src, onLoad) => {
  const img = new window.Image();
  img.src = src;
  img.onload = onLoad;
  img.onerror = onLoad;
};

const loadVideo = (src, onLoad) => {
  const video = document.createElement("video");
  video.src = src;
  video.preload = "auto";
  const timeout = setTimeout(onLoad, 5000);
  video.onloadeddata = () => {
    clearTimeout(timeout);
    onLoad();
  };
  video.onerror = () => {
    clearTimeout(timeout);
    onLoad();
  };
};

// Create preload context
const PreloadContext = createContext(false);
export const usePreload = () => useContext(PreloadContext);

// PreloadProvider without minimum delay
export const PreloadProvider = ({ children }) => {
  const [progress, setProgress] = useState(0);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const sources = Object.values(media);
    const totalFiles = sources.length;
    let loaded = 0;

    const handleFileLoaded = () => {
      loaded = Math.min(loaded + 1, totalFiles);
      setProgress((loaded / totalFiles) * 100);
      if (loaded === totalFiles) {
        document.fonts.ready.then(() => setIsReady(true));
      }
    };

    sources.forEach((src) => {
      if (!src) return handleFileLoaded();
      if (isImage(src)) loadImage(src, handleFileLoaded);
      else if (isVideo(src)) loadVideo(src, handleFileLoaded);
      else handleFileLoaded();
    });
  }, []);

  const isLoading = !isReady;

  return (
    <PreloadContext.Provider value={isReady}>
      {isLoading && (
        <div className="loading-screen">
          <div className="progress-bar">
            <div
              className="progress"
              style={{ width: `${Math.min(progress, 100)}%` }}
            />
          </div>
          <p>Loading... {Math.round(Math.min(progress, 100))}%</p>
        </div>
      )}
      {!isLoading && children}
    </PreloadContext.Provider>
  );
};
